<nav
  class="navbar navbar-expand-xxl navbar-dark fixed-top d-print-none border-bottom border-secondary"
  [class.bg-dark]="!systemEnvironment.isMarked"
  [class.test-system-bar]="systemEnvironment.isMarked"
>
  <a class="navbar-brand" routerLink="/"><img src="assets/logos/logo.png" alt="" /></a>
  @if (systemEnvironment.isMarked) {
    <span class="test-system-label">{{ systemEnvironment.label }}</span>
  }

  <!-- OUTSIDE the collapse on purpose: everything inside it hides behind the hamburger below
       1400px, and the appearance has to be reachable at every screen width (PRD D-9). -->
  @if (showAppearance()) {
    <app-appearance-menu class="order-xxl-last"></app-appearance-menu>
  }

  <button
    i18n-aria-label
    class="navbar-toggler"
    type="button"
    (click)="toggleNavbar()"
    aria-controls="navbarSupportedContent"
    aria-label="Toggle navigation"
    [attr.aria-expanded]="navbarOpen"
  >
    <span class="navbar-toggler-icon"></span>
  </button>

  <div class="collapse navbar-collapse" [class.show]="navbarOpen">
    <div class="d-flex justify-content-between w-100">
      @if (isAuthenticated$ | async) {
        <ul class="navbar-nav">
          @if (menus$ | async; as menus) {
            @for (menu of menus; track menu.name) {
              @if (menu.name !== authService.homeRoute) {
                @if (menu.name !== 'Settings') {
                  <li class="nav-item d-none" [class.d-xxl-block]="!isScannerApp()">
                    <a
                      class="nav-link text-nowrap text-white"
                      [routerLink]="menu.route"
                      [target]="menu.openInNewTab ? '_blank' : undefined"
                      routerLinkActive="active"
                      >{{ translationService.translateMenu(menu.name) }}</a
                    >
                  </li>
                }
                @if (menu.items.length === 0) {
                  <li class="nav-item d-xs-block d-xxl-none">
                    <a
                      class="nav-link text-nowrap text-white"
                      [routerLink]="menu.route"
                      [target]="menu.openInNewTab ? '_blank' : undefined"
                      routerLinkActive="active"
                      >{{ translationService.translateMenu(menu.name) }}</a
                    >
                  </li>
                }
                @if (menu.items.length > 0) {
                  <li
                    class="nav-item d-xs-block border-none"
                    [class.d-xxl-none]="!isScannerApp()"
                    [class.show]="menu.open"
                  >
                    <a class="nav-link text-nowrap text-white dropdown-toggle" (click)="openMenu(menus, menu)">
                      {{ translationService.translateMenu(menu.name) }}
                    </a>
                    <ul class="dropdown-menu bg-dark border-0 ms-3" [class.show]="menu.open">
                      @for (item of menu.items; track item.name) {
                        <li>
                          <a
                            class="dropdown-item text-nowrap text-white"
                            [routerLink]="item.route"
                            (click)="closeMenus(menus)"
                            >{{ translationService.translateMenu(item.name) }}</a
                          >
                        </li>
                      }
                    </ul>
                  </li>
                }
              }
            }
          }
        </ul>
      }
    </div>

    <!-- Projection slot for app-specific navbar controls (e.g. TmsWeb's help assistant).
         Apps that project nothing are unaffected. -->
    <ng-content></ng-content>

    <app-login-menu [isScannerApp]="isScannerApp()"></app-login-menu>
    @if (authService.isCustomer) {
      <app-customer-select></app-customer-select>
    }

    @if (menus$ | async) {
      <app-currency-select></app-currency-select>
    }

    @if (menus$ | async) {
      <app-language-select></app-language-select>
    }
  </div>
</nav>
